import script from "./MarketingShell.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketingShell.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import NeueButton from "@/components/neue/NeueButton.vue";
import NeueTabs from "@/components/neue/NeueTabs.vue";
script.components = Object.assign({}, { NeueButton, NeueTabs }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { NeueButton, NeueTabs }, script.__o.components);}